import { DefaultButton } from 'office-ui-fabric-react';
import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

import { BaseDetailCard } from '../BaseDetailCard/BaseDetailCard';
import { Body1Text, Body2BoldText } from '../Typography/Typography';
import { ISkillCardProps } from './SkillCard.types';

const Header = styled.div`
  background-color: #fff;
  width: auto;
  color: rgb(50, 49, 48);
  padding: 16px;
`;

const HeaderTitle = Body2BoldText;

const HeaderSubTitle = styled(Body1Text)`
  padding-top: 5px;
  display: block;
`;

const Footer = styled.div`
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 100%;
  padding: 12px 16px;
  background-color: #f2f2f2;
  box-sizing: border-box;
`;

const FooterContent = styled(Body1Text)`
  margin: 5px 0;
`;

const StyledButton = styled(DefaultButton)`
  margin: 5px 0;
`;

const Content = styled.div`
  padding: 40px 16px;
`;

export const SkillCard: FunctionComponent<ISkillCardProps> = props => {
  const {
    className,
    noSkillsAddedCardClick,
    headerTitle,
    headerSubtitle,
    children,
    footerText,
    footerButtonText,
    footerButtonOnClick,
  } = props;
  const numChildren = React.Children.toArray(children).filter(child => child !== null && child !== undefined).length;
  return (
    <BaseDetailCard className={className} onCardClick={noSkillsAddedCardClick}>
      {headerTitle || headerSubtitle ? (
        <Header className="baseCardHeader">
          <HeaderTitle>{headerTitle}</HeaderTitle> <br />
          <HeaderSubTitle className="baseCardHeader_title">{headerSubtitle}</HeaderSubTitle>
        </Header>
      ) : null}
      <Content className="baseCard_content">{numChildren > 0 ? children : <Body1Text>No skills added.</Body1Text>}</Content>
      {footerText ? (
        <Footer>
          <FooterContent>{footerText}</FooterContent>
          <StyledButton text={footerButtonText} onClick={footerButtonOnClick} />
        </Footer>
      ) : null}
    </BaseDetailCard>
  );
};

export default SkillCard;
